/* Homellence · Platzrechner, kompakt (Cowork, 27.09.2026, Runde 4)
   Karte mit drei klar getrennten Bedienstufen:
     1 Produkt (Knöpfe) · 2 Zustand (Schiebeschalter) · 3 Breite (nur Wäscheständer, Auswahlpunkte)
   Bühne einheitlich: Linie unten (Gold = Wand, Nachtblau = Boden) mit Legende,
   Ansicht unten links (von oben / von der Seite). Ein Kasten, der sich beim
   Umschalten bewegt; beim Eckregal (Seitenansicht) vier Körbe, vorher nebeneinander
   am Boden, mit Eckregal übereinander an der Stange in der Ecke. Ergebnis als ein Satz:
   „−94 % weniger Tiefe im Raum …“. Daten aus <script data-hl-calc-data>. */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function group(num, label) {
    var g = el('div', 'hl-calc__group');
    var l = el('p', 'hl-calc__glabel');
    l.appendChild(el('span', 'hl-calc__gnum', String(num)));
    l.appendChild(el('span', null, label));
    g.appendChild(l);
    return g;
  }
  function basketEl() {
    /* Eckkorb von der Seite: flacher Kasten */
    return el('span', 'hl-calc__basket');
  }
  function init(root) {
    if (root.__hlCalc) return;
    root.__hlCalc = true;
    var dataEl = root.querySelector('[data-hl-calc-data]');
    var panel = root.querySelector('[data-hl-calc-panel]');
    if (!dataEl || !panel) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var state = { sel: D.items[0].id, open: true, rv: 1 };
    var fmt = function (n) { return String(n).replace('.', D.dec); };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fb = panel.querySelector('noscript');
    if (fb) fb.remove();

    /* 1 Produkt */
    var g1 = group(1, D.labels.product);
    g1.classList.add('hl-calc__group--product');
    var chips = el('div', 'hl-calc__chips');
    var chipBtns = {};
    D.items.forEach(function (it) {
      var b = el('button', 'hl-calc__chip', it.name);
      b.type = 'button';
      b.addEventListener('click', function () { state.sel = it.id; state.open = true; render(); });
      chips.appendChild(b);
      chipBtns[it.id] = b;
    });
    g1.appendChild(chips);

    /* 2 Zustand + 3 Breite */
    var row = el('div', 'hl-calc__row');
    var g2 = group(2, D.labels.state);
    var sw = el('div', 'hl-calc__switch');
    var thumb = el('span', 'hl-calc__thumb');
    var bOpen = el('button', 'hl-calc__sw-btn'); bOpen.type = 'button';
    var bShut = el('button', 'hl-calc__sw-btn'); bShut.type = 'button';
    bOpen.addEventListener('click', function () { state.open = true; render(); });
    bShut.addEventListener('click', function () { state.open = false; render(); });
    sw.appendChild(thumb); sw.appendChild(bOpen); sw.appendChild(bShut);
    g2.appendChild(sw);
    var g3 = group(3, D.labels.width);
    g3.classList.add('hl-calc__group--width');
    var radios = el('div', 'hl-calc__radios');
    g3.appendChild(radios);
    row.appendChild(g2); row.appendChild(g3);

    /* Bühne */
    var stage = el('div', 'hl-calc__stage');
    var view = el('span', 'hl-calc__view');
    var draw = el('div', 'hl-calc__draw');
    var box = el('span', 'hl-calc__box');
    draw.appendChild(box);
    var pole = el('span', 'hl-calc__pole');
    draw.appendChild(pole);
    var baskets = [basketEl(), basketEl(), basketEl(), basketEl()];
    baskets.forEach(function (b) { draw.appendChild(b); });
    var line = el('span', 'hl-calc__line');
    var wall2 = el('span', 'hl-calc__wall2');
    var wall2Txt = el('span', 'hl-calc__wall2-txt', D.legend.wall);
    var legend = el('span', 'hl-calc__legend');
    var swatch = el('span', 'hl-calc__swatch');
    var legendTxt = el('span', null, '');
    legend.appendChild(swatch); legend.appendChild(legendTxt);
    [view, draw, line, wall2, wall2Txt, legend].forEach(function (n) { stage.appendChild(n); });

    var dims = el('p', 'hl-calc__dims');
    dims.setAttribute('aria-live', 'polite');

    /* Ergebnis als ein Satz */
    var result = el('p', 'hl-calc__result');
    var stat = el('strong', 'hl-calc__stat');
    var sl = el('span', 'hl-calc__sl');
    result.appendChild(stat); result.appendChild(sl);

    [g1, row, stage, dims, result].forEach(function (n) { panel.appendChild(n); });

    function resolve(it) {
      if (it.id !== 'rack') return it;
      var v = it.variants[state.rv], w = v[0], d = v[1];
      return {
        o: [w, d], c: [w, 2.8],
        od: w + ' ' + D.wcm + ', ' + d + ' ' + D.droom,
        cd: w + ' ' + D.wcm + ', ' + fmt(2.8) + ' ' + D.dwall,
        stat: '−' + Math.round((1 - 2.8 / d) * 100) + ' %',
        sl: D.slrack.replace('D', d)
      };
    }
    function extent(it) {
      if (it.variants) {
        var mw = 0, mh = 0;
        it.variants.forEach(function (v) { mw = Math.max(mw, v[0]); mh = Math.max(mh, v[1]); });
        return [mw, mh];
      }
      return [Math.max(it.o[0], it.c[0]), Math.max(it.o[1], it.c[1])];
    }
    function render() {
      var it = D.items.filter(function (x) { return x.id === state.sel; })[0];
      var r = resolve(it);
      Object.keys(chipBtns).forEach(function (k) {
        chipBtns[k].classList.toggle('is-on', k === state.sel);
        chipBtns[k].setAttribute('aria-pressed', k === state.sel ? 'true' : 'false');
      });

      bOpen.textContent = it.lo; bShut.textContent = it.lc;
      bOpen.classList.toggle('is-on', state.open); bShut.classList.toggle('is-on', !state.open);
      bOpen.setAttribute('aria-pressed', state.open ? 'true' : 'false');
      bShut.setAttribute('aria-pressed', state.open ? 'false' : 'true');
      var on = state.open ? bOpen : bShut;
      thumb.style.width = on.offsetWidth + 'px';
      thumb.style.transform = 'translateX(' + on.offsetLeft + 'px)';

      radios.innerHTML = '';
      g3.hidden = !it.variants;
      if (it.variants) {
        it.variants.forEach(function (v, i) {
          var b = el('button', 'hl-calc__radio' + (i === state.rv ? ' is-on' : ''));
          b.type = 'button';
          b.setAttribute('aria-pressed', i === state.rv ? 'true' : 'false');
          b.appendChild(el('span', 'hl-calc__dot'));
          b.appendChild(el('span', null, v[0] + ' cm'));
          b.addEventListener('click', function () { state.rv = i; render(); });
          radios.appendChild(b);
        });
      }

      view.textContent = D.hint[it.view] || '';
      stage.setAttribute('data-line', it.line || 'floor');
      stage.setAttribute('data-shape', it.shape || 'box');
      stage.setAttribute('data-open', state.open ? 'true' : 'false');
      legendTxt.textContent = D.legend[it.line || 'floor'];

      var dw = draw.clientWidth, dh = draw.clientHeight;
      if (it.shape === 'baskets') {
        box.hidden = true;
        /* Variante D (Seitenansicht): vorher vier Körbe nebeneinander am Boden,
           mit Eckregal übereinander an der Stange in der Ecke. */
        var bw = Math.max(34, Math.min(72, (dw - 40) / 5));
        var bh = Math.max(12, Math.min(20, (dh - 30) / 5));
        var ystep = Math.min(bh + 14, (dh - bh - 6) / 3);
        var x0 = 12;
        pole.style.left = Math.round(x0 + bw / 2 - 1.5) + 'px';
        baskets.forEach(function (b, i) {
          b.hidden = false;
          b.style.width = bw + 'px'; b.style.height = bh + 'px';
          var x = state.open ? x0 + i * (bw + 10) : x0;
          var y = state.open ? 0 : i * ystep;
          b.style.transform = 'translate(' + x + 'px, ' + (-y) + 'px)';
        });
        dims.hidden = true;
      } else {
        box.hidden = false;
        baskets.forEach(function (b) { b.hidden = true; });
        var ext = extent(it);
        var S = Math.min((Math.max(160, dw) * 0.8) / ext[0], (Math.max(60, dh) * 0.96) / ext[1]);
        var dim = state.open ? r.o : r.c;
        box.style.width = Math.round(dim[0] * S) + 'px';
        box.style.height = Math.max(5, Math.round(dim[1] * S)) + 'px';
        dims.hidden = false;
        dims.textContent = (state.open ? it.lo : it.lc) + ': ' + (state.open ? (r.od || it.od) : (r.cd || it.cd));
      }
      /* Ohne Minuszeichen: der Satz danach sagt schon „weniger“ (Kristin, 27.09.) */
      stat.textContent = String(r.stat || it.stat).replace(/^[−-]\s*/, '');
      sl.textContent = ' ' + (r.sl || it.sl);
    }
    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(render, 150); });
    if ('ResizeObserver' in window) {
      var lastW = stage.clientWidth;
      new ResizeObserver(function () {
        if (stage.clientWidth === lastW) return;
        lastW = stage.clientWidth;
        clearTimeout(t); t = setTimeout(render, 100);
      }).observe(stage);
    }

    /* Einmal vorführen: beim ersten Sichtkontakt kurz in die Aufbewahrung und zurück */
    if (!reduce && 'IntersectionObserver' in window) {
      var touched = false;
      panel.addEventListener('click', function () { touched = true; }, true);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.disconnect();
          setTimeout(function () {
            if (touched) return;
            state.open = false; render();
            setTimeout(function () { if (!touched) { state.open = true; render(); } }, 1600);
          }, 700);
        });
      }, { threshold: 0.6 });
      io.observe(stage);
    }
  }
  function boot() { document.querySelectorAll('[data-hl-calc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
